import { ReportWrapper } from './allReportWrapper'
import { useQueryResponseData, useQueryResponseLoading } from '../../../component'
import { ReportButton } from './reportPopup'
import { useAuth } from '../../../modules/auth'

// Styles for the loading spinner overlay
const styles = {
    borderRadius: '0.475rem',
    boxShadow: '0 0 50px 0 rgb(82 63 105 / 15%)',
    backgroundColor: '#fff',
    color: '#7e8299',
    fontWeight: '500',
    margin: '0',
    width: 'auto',
    padding: '1rem 2rem',
    top: 'calc(50% - 2rem)',
    left: 'calc(50% - 4rem)',
}

// Main wrapper component for all reports

/**
 * AllReportList component
 * Main wrapper for all reports, renders the ReportList inside ReportWrapper.
 */
const AllReportList = () => {
    return <ReportWrapper>
        <ReportList></ReportList>
    </ReportWrapper >
}

// Component to render the list of reports

/**
 * ReportList component
 * Renders the list of reports with download buttons and permission checks.
 * Shows loading spinner while data is loading and displays report sections for different day ranges and today.
 */
export const ReportList = () => {
    const { currentUser } = useAuth()
    // Get report data and loading state from custom hooks
    const reports = useQueryResponseData();
    const isLoading = useQueryResponseLoading()

    const globalDownload = currentUser?.accesses?.permissions?.includes('download')
    // report-list already returns only reports assigned to this project for the user's role
    const allowedReports = reports || []
    const canDownload = globalDownload || (currentUser?.accesses?.modules_permissions?.reports?.actions || []).includes('download')
    const visibleReports = canDownload ? allowedReports : []

    return <ReportWrapper>
        <div className='container-fluid mt-3'>
            <div className="d-flex flex-column flex-row-fluid gap-7 gap-lg-10">
                {/* Show loading spinner while data is loading */}
                {isLoading && <div style={{ ...styles, position: 'absolute', textAlign: 'center' }}>
                    <button class="btn btn-primary" type="button" disabled>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"> </span> Loading...
                    </button>
                </div>}
                {/* Card for "Report By Days" section */}
                <div style={{ border: '1px solid #E6E6E6' }} className="card">
                    {/* Card header */}
                    <div className="card-header" style={{ minHeight: '39px', background: '#f7f7f7' }}>
                        <div className="card-title fw-semibold fs-4 py-1">
                            <i class="bi bi-card-text text-danger fs-2 me-2"></i> Report By Days
                        </div>
                    </div>
                    {/* Card body with report buttons for different day ranges */}
                    <div className="card-body ">
                        {canDownload ?
                            <div className="d-flex">
                                {visibleReports.map((report, index) => {
                                    // Alternate background color for buttons
                                    const backgroundColor = index % 2 === 0 ? '#474747' : '#d01921';
                                    return <div key={index} className="me-2">
                                        <ReportButton
                                            report_id={report?.id}
                                            download_url={{
                                                "7": report?.day_7_download_url,
                                                "15": report?.day_15_download_url,
                                                "30": report?.day_30_download_url,
                                                "1": report?.all_download_url,
                                            }}
                                            title={report?.report_name}
                                            description=""
                                            reportPopup={true}
                                            order={report?.order}
                                            background={backgroundColor}
                                        />
                                    </div>
                                })}
                                {visibleReports.length === 0 && !isLoading && (
                                    <div className='badge badge-light-warning fw-semibolder'>No reports assigned to your role</div>
                                )}
                            </div>
                            : <div className='badge badge-light-danger fw-semibolder'>Permission Denied</div>
                        }
                    </div>
                </div>
                {/* Card for "Today Report" section */}
                <div style={{ border: '1px solid #E6E6E6' }} className="card">
                    {/* Card header */}
                    <div className="card-header" style={{ minHeight: '39px', background: '#f7f7f7' }}>
                        <div className="card-title fw-semibold fs-4 py-1">
                            <i class="bi bi-card-text text-danger fs-2 me-2"></i>  Today Report
                        </div>
                    </div>
                    {/* Card body with report buttons for today's reports */}
                    <div className="card-body ">
                        {canDownload ?
                            <div className="d-flex">
                                {visibleReports.map((report, index) => {
                                    const backgroundColor = index % 2 === 0 ? '#474747' : '#d01921';
                                    return <div key={index} className="me-2">
                                        <ReportButton
                                            report_id={report?.id}
                                            link={`${process.env.REACT_APP_API_URL}/report-download/` + report?.id}
                                            title={report?.report_name}
                                            description=""
                                            order={report?.order}
                                            background={backgroundColor}
                                        />
                                    </div>
                                })}
                                {visibleReports.length === 0 && !isLoading && (
                                    <div className='badge badge-light-warning fw-semibolder'>No reports assigned to your role</div>
                                )}
                            </div>
                            : <div className='badge badge-light-danger fw-semibolder'>Permission Denied</div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </ReportWrapper >
}

export { AllReportList }